import Head from 'next/head';
import { NextSeo } from 'next-seo';
import ClassroomHomepage from '@cont/ClassroomHomepage/ClassroomHomepage';
import { getImage } from '@utils/imageHelper';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Classroom = () => {
  const title =
    'Unacademy Live Classroom -  A new classroom for you & your students';
  const description =
    'Create a more centralized, accessible, and powerful learning environment for your students';
  const canonicalURL = 'https://unacademy.com/classroom';
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: getImage('classroom/og-image.png'),
              width: 800,
              height: 600
            }
          ],
          url: canonicalURL
        }}
      />
      <Head>
        <title>{title}</title>
      </Head>

      <ClassroomHomepage />
    </>
  );
};

Classroom.pageInfo = {
  isMWebSupported: true,

  layoutOptions: {
    isCheckoutUrl: true,
    hideSearch: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default Classroom;

Classroom.getInitialProps = setupInitialProps(
  async ({ store, isServer, res }) => {
    const { auth } = store.getState();
    const { isLoggedIn, me } = auth || {};
    if (isServer) {
      if (isLoggedIn && !me.isSchoolEducator) {
        res.writeHead(302, {
          Location: '/'
        });
        return res.end();
      }
      if (isLoggedIn && me.isSchoolEducator) {
        res.writeHead(302, {
          Location: '/classroom/dashboard'
        });
        return res.end();
      }
    }
    return {};
  },
  Classroom.pageInfo
);
Classroom.Layout = Layout;
Classroom.Wrapper = PageReduxProvider;
